import { REVIEWBOOST_V4_UI_ENABLED } from "./review-boost-v4-ui";
/** Presentation-only canary. The server remains the authority for every product operation. */
export function reviewBoostV3UiEnabled(environment: Record<string, unknown> | undefined): boolean {
  return environment?.VITE_CLICKDIALOG_REVIEWBOOST_V3_UI === "true";
}

// Vite populates import.meta.env in the browser; source/Node tests do not.
export const REVIEWBOOST_V3_UI_ENABLED = reviewBoostV3UiEnabled(import.meta.env) || REVIEWBOOST_V4_UI_ENABLED;
